import React from 'react';
import { FDStack } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';

export const LayoutPaperActions = ({ children }) => {
  return (
    <FDStack justifyContent={'center'} spacing={3} wrap {...dataAttrs('layout-paper-actions')}>
      {children}
    </FDStack>
  );
};

LayoutPaperActions.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};
